export default "__VITE_ASSET__DkeVH$7R__"